<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-title" id="fm-1">A<span class="smallcaps">BBREVIATIONS</span></h1>
<table>
<tbody>
<tr>
<td class="wid25">
<p class="t-left">ACC</p></td>
<td class="wid70">
<p class="t-left">Abilene Christian College</p></td>
</tr>
<tr>
<td class="wid25">
<p class="t-left"><em class="italic">ACR</em></p></td>
<td class="wid70">
<p class="t-left"><em class="italic">American Christian Review</em></p></td>
</tr>
<tr>
<td class="wid25">
<p class="t-left">ACU</p></td>
<td class="wid70">
<p class="t-left">Abilene Christian University</p></td>
</tr>
<tr>
<td class="wid25">
<p class="t-left"><em class="italic">BB</em></p></td>
<td class="wid70">
<p class="t-left"><em class="italic">Bible Banner</em></p></td>
</tr>
<tr>
<td class="wid25">
<p class="t-left"><em class="italic">CB</em></p></td>
<td class="wid70">
<p class="t-left"><em class="italic">Christian Baptist</em></p></td>
</tr>
<tr>
<td class="wid25">
<p class="t-left"><em class="italic">CC</em></p></td>
<td class="wid70">
<p class="t-left"><em class="italic">Christian Chronicle</em></p></td>
</tr>
<tr>
<td class="wid25">
<p class="t-left"><em class="italic">CE</em></p></td>
<td class="wid70">
<p class="t-left"><em class="italic">Christian Echo</em></p></td>
</tr>
<tr>
<td class="wid25">
<p class="t-left"><em class="italic">CF</em></p></td>
<td class="wid70">
<p class="t-left"><em class="italic">Contending for the Faith</em></p></td>
</tr>
<tr>
<td class="wid25">
<p class="t-left"><em class="italic">CG</em></p></td>
<td class="wid70">
<p class="t-left">David Lipscomb, <em class="italic">Civil Government: Its Origin, Mission, and Destiny, and the Christian’s Relation to It</em> (Nashville: Gospel Advocate Publishing, 1889), <a href="https://digitalcommons.acu.edu/crs_books/63/" target="_blank">https://digitalcommons.acu.edu/crs_books/63/</a></p></td>
</tr>
<tr>
<td class="wid25">
<p class="t-left"><em class="italic">CL</em></p></td>
<td class="wid70">
<p class="t-left"><em class="italic">Christian Leader</em></p></td>
</tr>
<tr>
<td class="wid25">
<p class="t-left"><em class="italic">CM</em></p></td>
<td class="wid70">
<p class="t-left"><em class="italic">Christian Messenger</em></p></td>
</tr>
<tr>
<td class="wid25">
<p class="t-left"><em class="italic">COCTFC</em></p></td>
<td class="wid70">
<p class="t-left"><em class="italic">Churches of Christ in the Twenty-First Century Oral History Project</em>, <a href="https://digitalcommons.acu.edu/coc_21stc_oralhistory/" target="_blank">https://digitalcommons.acu.edu/coc_21stc_oralhistory/</a></p></td>
</tr>
<tr>
<td class="wid25">
<p class="t-left"><em class="italic">ESCM</em></p></td>
<td class="wid70">
<p class="t-left"><em class="italic">Encyclopedia of the Stone-Campbell Movement</em></p></td>
</tr>
<tr>
<td class="wid25">
<p class="t-left"><em class="italic">FCC</em></p></td>
<td class="wid70">
<p class="t-left"><em class="italic">First Century Christian</em></p></td>
</tr>
<tr>
<td class="wid25">
<p class="t-left"><em class="italic">FF</em></p></td>
<td class="wid70">
<p class="t-left"><em class="italic">Firm Foundation</em></p></td>
</tr>
<tr>
<td class="wid25">
<p class="t-left"><em class="italic">GA</em></p></td>
<td class="wid70">
<p class="t-left"><em class="italic">Gospel Advocate</em></p></td>
</tr>
<tr>
<td class="wid25">
<p class="t-left"><em class="italic">GG</em></p></td>
<td class="wid70">
<p class="t-left"><em class="italic">Gospel Guardian</em></p></td>
</tr>
<tr>
<td class="wid25">
<p class="t-left"><em class="italic">MH</em></p></td>
<td class="wid70">
<p class="t-left"><em class="italic">Millennial Harbinger</em></p></td>
</tr>
<tr>
<td class="wid25">
<p class="t-left">PTP</p></td>
<td class="wid70">
<p class="t-left">Polishing the Pulpit</p></td>
</tr>
<tr>
<td class="wid25">
<p class="t-left"><em class="italic">RQ</em></p></td>
<td class="wid70">
<p class="t-left"><em class="italic">Restoration Quarterly</em></p></td>
</tr>
<tr>
<td class="wid25">
<p class="t-left">Sewell Papers</p></td>
<td class="wid70">
<p class="t-left">Sewell Papers, Center for Restoration Studies, Abilene Christian University</p></td>
</tr>
<tr>
<td class="wid25">
<p class="t-left"><em class="italic">SS</em></p></td>
<td class="wid70">
<p class="t-left"><em class="italic">Spiritual Sword</em></p></td>
</tr>
<tr>
<td class="wid25">
<p class="t-left"><em class="italic">20th CC</em></p></td>
<td class="wid70">
<p class="t-left"><em class="italic">20th Century Christian</em></p></td>
</tr>
<tr>
<td class="wid25">
<p class="t-left">WVBS</p></td>
<td class="wid70">
<p class="t-left">World Video Bible School</p></td>
</tr>
<tr>
<td class="wid25">
<p class="t-left"><em class="italic">WW</em></p></td>
<td class="wid70">
<p class="t-left"><em class="italic">Word and Work</em></p></td>
</tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006_Abbreviations.vue?ae059db2